<!-- a chunky game card in the category color, with a darker edge at the bottom; finished it turns green, and the icon tile turns white so the category color stays visible. -->
<div
  class="relative flex size-full flex-col items-center rounded-2xl border-b-8 px-2 py-3 text-center text-white transition-transform duration-150"
  [class]="
    finished()
      ? 'border-green-700 bg-green-500'
      : 'pointer-events-auto cursor-pointer border-black/25 bg-(--category-color) hover:-translate-y-1 hover:scale-105'
  "
  role="button"
  [attr.tabindex]="finished() ? -1 : 0"
  [attr.aria-disabled]="finished()"
  (click)="onClick()"
  (keydown.enter)="onClick()"
  (keydown.space)="$event.preventDefault(); onClick()"
>
  @if (finished()) {
    <span class="absolute -top-3 -right-3 flex size-9 items-center justify-center rounded-full border-2 border-white bg-green-500 text-lg">
      <fa-icon [icon]="faCheck" />
    </span>
  }

  <div
    class="mb-2 flex size-12 shrink-0 items-center justify-center rounded-xl text-2xl"
    [class]="finished() ? 'bg-white text-(--category-color)' : 'bg-white/20'"
  >
    <fa-icon [icon]="mechanic().icon" />
  </div>

  <p class="font-default leading-tight font-bold">{{ name() }}</p>

  @if (details().length > 0) {
    <p class="mt-0.5 text-xs leading-tight" [class]="finished() ? 'text-green-100' : 'text-white/80'">{{ details().join(' · ') }}</p>
  }

  @if (topics().length > 0) {
    <div class="mt-2 flex flex-wrap justify-center gap-1">
      @for (topic of topics(); track $index) {
        <span class="rounded-full bg-white px-2 py-0.5 text-xs text-(--category-color)">{{ topic }}</span>
      }
    </div>
  }
</div>
